import React from "react";
import { Box } from "@chakra-ui/react";
import { avatarUrl } from "../../helpers/utils";

const ProfileImage = ({ imageUrl, name, size = "100px", ...props }) => {
    const numericSize =
        typeof size === "string" && size.endsWith("px")
            ? parseInt(size)
            : Number(size) || 100;

    let finalImageUrl;
    if (imageUrl) {
        if (imageUrl.startsWith("https://cdn.filestackcontent.")) {
            const urlParts = imageUrl.split("/");
            const fileHandle = urlParts.pop();
            finalImageUrl = `${urlParts.join("/")}/resize=width:${numericSize},height:${numericSize},fit:crop/${fileHandle}`;
        } else {
            finalImageUrl = imageUrl;
        }
    } else {
        finalImageUrl = avatarUrl(name, "random", "true");
    }

    return (
        <Box
            style={{
                background: `center / cover no-repeat url(${finalImageUrl})`,
            }}
            height={size}
            width={size}
            borderRadius="50%"
            aria-label={name || "User"}
            {...props}
        />
    );
};

export default ProfileImage;